import axios from 'axios';

// Extend axios's config type so `skipAuthRefresh` is recognized everywhere
declare module 'axios' {
    export interface AxiosRequestConfig {
        skipAuthRefresh?: boolean;
    }
}

const SERVER_IP = 'api.easternerian.co.za';

export const ROOT_URL   = `https://${SERVER_IP}/`;
export const SERVER_URL = ROOT_URL + 'delivery_quick_quick/';

//export const SERVER_URL = 'http://127.0.0.1:8000/delivery_quick_quick/';
//export const SERVER_URL = 'http://159.203.190.150:8000/delivery_quick_quick/'; // for online server without https

//export const SERVER_URL = `https://${SERVER_IP}/delivery_quick_quick/`;

export const SOCKET_URL = `wss://${SERVER_IP}/ws/`;

const axiosInstance = axios.create({
    baseURL: SERVER_URL,
});

// Helper — clear auth state and redirect to login
const redirectToLogin = () => {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    window.location.href = '/login'; // ⚠️ match your actual route casing exactly (e.g. '/logIn' if that's your route)
};

// Request interceptor — attach access token
axiosInstance.interceptors.request.use(
    (config: any) => {
        const token = localStorage.getItem('access');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error: any) => Promise.reject(error)
);


axiosInstance.interceptors.response.use(
    (response: any) => response,
    async (error: any) => {
        const originalRequest = error.config;

        // Skip refresh/redirect logic entirely for requests explicitly flagged
        if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.skipAuthRefresh) {
            originalRequest._retry = true;

            const refreshToken = localStorage.getItem('refresh');

            if (!refreshToken) {
                console.warn('🔴 No refresh token — redirect triggered by:', originalRequest?.url, originalRequest?.method);
                redirectToLogin();
                return Promise.reject(error);
            }

            try {
                const response = await axios.post(`${SERVER_URL}refresh_token/`, {
                    refresh: refreshToken,
                });

                const newAccessToken = response.data.access;
                localStorage.setItem('access', newAccessToken);

                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                console.warn('🔴 Auth redirect triggered by:', originalRequest?.url, originalRequest?.method);
                redirectToLogin();
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;